<template>
   <g>
      <path
         d="M4.7793 11.1602C4.31445 11.1602 3.93555 10.9941 3.64258 10.6621L0.794922 7.39258C0.650391 7.23242 0.550781 7.08008 0.496094 6.93555C0.441406 6.79102 0.414062 6.63477 0.414062 6.4668C0.414062 6.09961 0.539062 5.79297 0.789062 5.54688C1.03906 5.30078 1.35352 5.17773 1.73242 5.17773C2.13867 5.17773 2.47266 5.32617 2.73438 5.62305L4.75586 7.95508L8.83984 1.57422C8.99609 1.33203 9.16406 1.16016 9.34375 1.05859C9.52344 0.957031 9.74023 0.90625 9.99414 0.90625C10.373 0.90625 10.6895 1.0293 10.9434 1.27539C11.1973 1.51758 11.3242 1.82227 11.3242 2.18945C11.3242 2.31836 11.3027 2.45508 11.2598 2.59961C11.2168 2.74023 11.1484 2.88086 11.0547 3.02148L5.96875 10.5742C5.70312 10.9648 5.30664 11.1602 4.7793 11.1602Z"
         fill="#22B56C"
      />
   </g>
</template>

<script>
export default {
   data() {
      return {
         name: 'icon-flag-verified',
         viewBox: '0 0 12 12',
         width: 12,
         height: 12,
      };
   },
};
</script>
